module.exports = __webpack_public_path__ + "static/media/rugDead.8bda9f65.png";